import React from 'react';
import RosterBadge from '../../../../components/roster-badge';
import type {SummaryRoster} from './summarise';

// The badge carries identity in every use; the name sits beside it and truncates in a narrow panel
const RosterName = ({roster}: {roster: SummaryRoster}) => (
    <span className='summary-panel__roster' title={roster.name}>
        <RosterBadge slot={roster.slot} />
        <span className='summary-panel__roster-name'>{roster.name}</span>
    </span>
);

export default RosterName;
